(function () {
  'use strict';

  // FAQ accordion is native <details>/<summary>; nothing to wire up.

  // Mobile nav toggle
  function initNavToggle() {
    var btn = document.querySelector('[data-nav-toggle]');
    if (!btn) return;
    var menu = document.querySelector('[data-nav-menu]');
    if (!menu) return;
    btn.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Mobile slide-in drawer: open/close via hamburger, ✕, scrim, Esc.
  // Locks body scroll while open and returns focus to the trigger on close.
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var opener = document.querySelector('[data-drawer-open]');
    var scrim = document.querySelector('.drawer-scrim');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
      drawer.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('drawer-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (opener) opener.addEventListener('click', open);
    drawer.parentNode.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Accordions inside the drawer (Shop mega → expandable section).
    drawer.querySelectorAll('[data-acc-trigger]').forEach(function (trigger) {
      var panel = trigger.parentNode.querySelector('[data-acc-panel]');
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (panel) {
          if (isOpen) { panel.setAttribute('hidden', ''); }
          else { panel.removeAttribute('hidden'); }
        }
      });
    });
  }

  // Mega menu: click trigger toggles, outside-click and Escape close.
  // Desktop hover/focus-within is handled by CSS.
  function initMegaMenu() {
    var megas = document.querySelectorAll('[data-mega]');
    if (!megas.length) return;

    function closeAll(except) {
      megas.forEach(function (m) {
        if (m === except) return;
        var trigger = m.querySelector('[data-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    megas.forEach(function (mega) {
      var trigger = mega.querySelector('[data-mega-trigger]');
      var panel = mega.querySelector('[data-mega-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var open = trigger.getAttribute('aria-expanded') === 'true';
        closeAll(mega);
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });

      panel.addEventListener('click', function (e) {
        if (e.target.closest('a')) trigger.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mega]')) closeAll(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  // Collection masonry tabs (homepage filter, client-side label change only)
  function initMasonryTabs() {
    document.querySelectorAll('[data-mason-tabs]').forEach(function (tabs) {
      tabs.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (a.dataset.scope) return;
          e.preventDefault();
          tabs.querySelectorAll('a').forEach(function (x) { x.classList.remove('is-active'); });
          a.classList.add('is-active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initNavToggle();
      initDrawer();
      initMegaMenu();
      initMasonryTabs();
    });
  } else {
    initNavToggle();
    initDrawer();
    initMegaMenu();
    initMasonryTabs();
  }
})();
